// src/api/axios.js
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '/api', // Replace with your API base URL
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add an interceptor to include the token in requests
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Add a response interceptor to handle errors globally
axiosInstance.interceptors.response.use(
    (response) => response, // Pass through successful responses
    (error) => {
        // Check if error.response exists
        if (error.response) {
            // Customize error message based on the status code or API response
            const message =
                error.response.data?.message ||
                `API call failed with status ${error.response.status}`;
            // Display a popup or toast (this example assumes you use a library like Toastify or similar)
            // console.error(message); // Replace with your preferred popup implementation
        } else {
            // Handle network or other unknown errors
            // console.error('Network error or server not reachable.');
        }
        return Promise.reject(error); // Reject the error for any further handling
    }
);

// Decode roles from JWT
export const getUserRoles = () => {
    const token = localStorage.getItem('token');
    if (token) {
        const decoded = jwtDecode(token);
        return decoded.roles.map((role) => role.name); // Assuming role structure includes `name`
    }
    return [];
};

export const getUser = () => {
    const token = localStorage.getItem('token');
    if (token) {
        const decoded = jwtDecode(token);
        return decoded;
    }
    return null;
}

export default axiosInstance;
